import CustomInput from "@Components/Basic/Input/CustomInput";
import RegistrationLayout from "@Components/RagistrationLayout";
import { useFormik } from "formik";
import * as yup from "yup";
import {
  Box,
  Grid,
  IconButton,
  InputAdornment,
  Typography,
} from "@mui/material";
import { useState } from "react";
import { useRouter } from "next/router";
import { StyledGreenButton } from "@Styled/Common";
import Link from "next/link";
import { apiUser } from "@Services/API/IndividualApi's/User";
import { useDispatch } from "react-redux";
import { UserActions } from "@Redux-Store/Actions/UserActions";
import { CartActions } from "@Redux-Store/Actions/CartActions";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Spinner from "../Common/Spinner";
import { theme } from "@Definitions/Styled";
import AES from "crypto-js/aes";
interface IFormikValues {
  password: string;
}
const validationSchema = yup.object({
  password: yup.string("Enter your password").required("Password is required"),
});
interface LoginPasswordProps {
  phoneNumber: string;
  handleIndexChange: Function;
}
const LoginPassword = ({
  phoneNumber,
  handleIndexChange,
}: LoginPasswordProps) => {
  const router = useRouter();
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [spinner, setSpinner] = useState<boolean>(false);
  const [otpSpinner, setOtpSpinner] = useState<boolean>(false);
  const dispatch = useDispatch();

  const CRYPTO_SECRET_KEY = process.env.NEXT_PUBLIC_CRYPTO_SECRET_KEY!;

  const formik = useFormik({
    initialValues: {
      password: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values: IFormikValues) => {
      setSpinner(true);
      var aesEncTrans = AES.encrypt(
        JSON.stringify(values.password),
        CRYPTO_SECRET_KEY
      ).toString();
      const obj = {
        phoneNumber: phoneNumber,
        password: aesEncTrans,
      };
      try {
        const response = await apiUser.login(obj);
        setSpinner(false);
        dispatch(UserActions.getMyDetails());
        dispatch(CartActions.GetMyCart());
        if (router.query.hasOwnProperty("checkout")) {
          router.push("/checkout");
          return;
        }
        if (globalThis.sessionStorage.currentPath == "/register") {
          router.push("/");
        } else {
          router.back();
        }
      } catch (err) {
        setSpinner(false);
        console.log(err);
      }
    },
  });
  const handleGetAnOtp = async () => {
    setOtpSpinner(true);
    const obj = {
      phoneNumber: phoneNumber,
    };
    try {
      const response = await apiUser.loginWithOtp(obj);
      setOtpSpinner(false);
      handleIndexChange();
    } catch (err) {
      setOtpSpinner(false);
      console.log(err);
    }
  };
  const handleClickShowPassword = () => {
    setShowPassword((prevVal) => !prevVal);
  };
  const handleMouseDownPassword = (
    event: React.MouseEvent<HTMLButtonElement>
  ) => {
    event.preventDefault();
  };
  return (
    <RegistrationLayout
      title="Login To Your Account"
      dividerText="Or"
      buttonText="Get an Otp on your phone"
      otpSpinner={otpSpinner}
      onButtonClicked={() => handleGetAnOtp()}
      loginModal={true}
    >
      <Grid item>
        <form onSubmit={formik.handleSubmit}>
          <Grid sx={{ marginBottom: "1rem" }}>
            <Box>
              <Link href="/forgot-password">
                <Typography
                  textAlign="right"
                  sx={{ fontSize: "0.8rem", cursor: "pointer" }}
                >
                  Forgot Password
                </Typography>
              </Link>
            </Box>
            <CustomInput
              fullWidth
              id="password"
              name="password"
              label="Password"
              type={showPassword ? "text" : "password"}
              value={formik.values.password}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              error={formik.touched.password && Boolean(formik.errors.password)}
              helperText={formik.touched.password && formik.errors.password}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <span></span>
          <StyledGreenButton fullWidth type="submit">
            {spinner ? <Spinner spinColor={theme.palette.neutral.main} /> : ""}{" "}
            Login
          </StyledGreenButton>
        </form>
      </Grid>
    </RegistrationLayout>
  );
};
export default LoginPassword;
